import { authOperations } from '../../src/views/containers/Login/state';
import * as loginActions from '../../src/views/containers/Login/state/actions';
import { WEBHRIS_OLD_LOGIN_URL, IDS_TOKEN_COOKIE, USER_ACCESS } from '../../src/config/settings';
import cookie from 'react-cookies';
import { logoutUser } from '@Containers/Login/state/operations';
import { getStore } from '@AppRedux/store';

export default async function() {
    const store = getStore();

    if (cookie.load(IDS_TOKEN_COOKIE)) {
        await store.dispatch(authOperations.loginUser()).then((response) => {
            localStorage.setItem(USER_ACCESS, JSON.stringify(response.data));
            store.dispatch(loginActions.setAuthenticated(true));
        });
    }
    else {
        store.dispatch(loginActions.setAuthenticated(false));
        store.dispatch(logoutUser());
        window.location.replace(WEBHRIS_OLD_LOGIN_URL + "?redirect=hrrec") 
    }
}
